// extracted by extract-css-chunks-webpack-plugin
module.exports = {"regItemList":"mark-purchased-modal__regItemList__3z7Y7","regItem":"mark-purchased-modal__regItem__1H9HL"};